import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-16">
      <div className="relative rounded-lg overflow-hidden p-10 md:p-16 text-center">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20gradient%20abstract%20background%20with%20overlapping%20comic%20panels%20and%20ink%20splashes%20orange%20coral%20and%20cream%20tones%20modern%20minimal%20design%20soft%20textures%20digital%20art&width=1400&height=500&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>

        <div className="relative z-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
            还没找到想看的漫画？
          </h2>
          <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto mb-8">
            探索我们的漫画大全，韩漫、日漫、国漫一应俱全，总有你喜欢的作品等待发现。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/kr"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-accent-500 text-white font-medium text-sm hover:bg-accent-600 transition-colors cursor-pointer"
            >
              韩漫专区
            </Link>
            <Link
              to="/category/jp"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
            >
              日漫专区
            </Link>
            <Link
              to="/category/cn"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-secondary-500 text-white font-medium text-sm hover:bg-secondary-600 transition-colors cursor-pointer"
            >
              国漫专区
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}